<template>
  <button
    class="button secondary expanded"
    @click="scrollIntoMembers"
  >
    Shop The Collection
  </button>
</template>

<script setup>
const scrollIntoMembers = (e) => {
  /** @type {HTMLElement | null} */
  const membersOfMaster = document.getElementById('members-of-master');
  if (membersOfMaster) {
    e.target.blur();
    membersOfMaster.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
};
</script>
